import { Question, QuestionState, Course, Review, User, UserCourse, Answer } from './streber-interfaces';
import { ToolsService } from './tools.service';

export class QuestionManager {

  public static newReview(u: User): Review {
    return {
      user: u,
      forVersion: 0,
      wording: 3,
      complexity: 2,
      understandability: 3,
      notCorrect: false,
      mustBeReported: false,
      comment: ""
    }
  }

  public static createUpdateObjectForResubmit(q: Question): any {
    return {
      version: q.version,
      topic: q.topic,  
      questionText: q.questionText,
      answers: q.answers,
      state: q.state,
      remark: q.remark,
      countReviewsLatestVersion: 0
    }
  }

  private static createCopyOfAnswer(a: Answer): Answer {
    return <Answer>{text: a.text, correct: a.correct}
  }
  private static createCopyOfAnswers(answers: Answer[]): Answer[] {
    let coll: Answer[] = [];
    answers.forEach((a)=>{
      coll.push(this.createCopyOfAnswer(a));
    });
    return coll;
  }
  public static createCopyForComparisn(q: Question): any {
    return {
      topic: q.topic,  
      questionText: q.questionText,
      answers: this.createCopyOfAnswers(q.answers),
      remark: q.remark
    }
  }
  private static areAnswersUnChanged(oldAnswers: Answer[],newAnswers: Answer[]): boolean {
    let unchanged = true;
    for (let i=0; i<oldAnswers.length; i++) {
      if (oldAnswers[i].correct != newAnswers[i].correct) unchanged = false;
      if (oldAnswers[i].text != newAnswers[i].text) unchanged = false;
    }
    return unchanged;
  }
  public static isQuestionDataUnchanged(oldQuestion: any, newQuestion: Question): boolean {
    return (
      newQuestion.topic == oldQuestion.topic &&
      newQuestion.questionText == oldQuestion.questionText &&
      newQuestion.remark == oldQuestion.remark &&
      this.areAnswersUnChanged(oldQuestion.answers, newQuestion.answers)
    );
  }

  public static newQuestion(): Question {
    return {
      qid: "", //GUID beim Speichern
      mid: "", //FK
      cid: "", //FK
      creator: {uid: "", nickname:""}, //mandatory!!!
      version: 1,
      topic: "", //aus Topic-Liste pro Modul 
      questionText: "",
      answers: [
        {
          text: "",
          correct: false
        },
        {
          text: "",
          correct: false 
        },
        {
          text: "",
          correct: false
        },
        {
          text: "",
          correct: false
        },
      ],
      state: QuestionState.Saved,
      remark: "",
      messages: [],
      reviews: [],
      countReviewsLatestVersion: 0,
      lastReview: null,
      created: null,
      reviewStatistic: {
        countReviews: 0,
        sumWording: 0,
        avgWording: 0,
        sumUnderstandability: 0,
        avgUnderstandability: 0,
        countComplexity1: 0,
        countComplexity2: 0,
        countComplexity3: 0,
      },
      bestReviewerId: ""
    }
  }

  public static findErrorsForSave(q: Question, language: string): string {
    let msg: string = "";
    let br: string = "<br>";
    if (language=="de") {
      if (q.cid === "") msg = msg+br+"Course ID (cid) = leer";
      if (q.mid === "") msg = msg+br+"Modul ID (mid) mid = leer";
      if (q.topic.length==0) msg = msg+br+"Das Thema der Frage wurde nicht gesetzt.";
      if (q.questionText.length<10) msg = msg+br+"Frage muss mindestens 10 Zeichen haben.";
      if (q.answers[0].text.length==0) msg = msg+br+"Antwort 1 ist leer.";
      if (q.answers[1].text.length==0) msg = msg+br+"Antwort 2 ist leer.";
      if (q.answers[2].text.length==0) msg = msg+br+"Antwort 3 ist leer.";
      if (q.answers[3].text.length==0) msg = msg+br+"Antwort 4 ist leer.";
      if (!q.answers[0].correct &&
          !q.answers[1].correct &&
          !q.answers[2].correct &&
          !q.answers[3].correct) msg = msg+br+"Mindestens eine Antwort muss korrekt sein (oder mehr)";
      if (msg.length>0) msg = msg.substring(4);
    } else {
      if (q.cid === "") msg = msg+br+"Course ID (cid) = empty";
      if (q.mid === "") msg = msg+br+"Modul ID (mid) mid = empty";
      if (q.topic.length==0) msg = msg+br+"Topic must be set.";
      if (q.questionText.length<10) msg = msg+br+"Question minimum lenght: 10 characters";
      if (q.answers[0].text.length==0) msg = msg+br+"Answer 1 is missing.";
      if (q.answers[1].text.length==0) msg = msg+br+"Answer 2 is missing.";
      if (q.answers[2].text.length==0) msg = msg+br+"Answer 3 is missing.";
      if (q.answers[3].text.length==0) msg = msg+br+"Answer 4 is missing.";
      if (!q.answers[0].correct &&
          !q.answers[1].correct &&
          !q.answers[2].correct &&
          !q.answers[3].correct) msg = msg+br+"At least one answer must be correct (or more)";
      if (msg.length>0) msg = msg.substring(4);
    }
    
    return msg;
  }

  public static newUserCourse(uid: string, cid: string): UserCourse {
    return { 
      uid: uid,
      cid: cid,
      points: 0,
      level: 1,
      days: 0, 
      lastDay: null, //firebase timestamp
      gold: 0, //Währung
      countQuestions: 0, // Anzahl der geschriebenen Questions
      countQuestionsAccepted: 0,
      countBestReviewer: 0,
      countReviews: 0, //Anzahl der geschriebenen Reviews
      countStandardTrainings: 0, //Anzahl der absolvierten Standard-Trainings
      countAdvancedTrainings: 0, //Anzahl der absolvierten Advanced-Trainings
      settingShowInHighScore: true,
      settingUseTwoStepReviewSubmit: true,
      isLocked: false,
      dailyTrainingCounter: 0, //Trainings done today -> set to zero on next day
      weekStartPoints: 0, //set in calcalteHighScore: Points where User started thsi week
      lastWeekPoints: 0, //set in calcalteHighScore: WeekPoints from lastweek at end
      lastWeekRank: 0, //set in calcalteHighScore: Rank last week at end
      lastWeekPromotion: 0 //set in calcalteHighScore: +1,0,-1 from last week
  }
  }
}
